import React from "react";
import PropTypes from "prop-types";

import BodyText from "core/BodyText";

import colors from "core/colors";

import { Container, TextContainer } from "./styles";

const HoverTextOverlay = ({ hoverText }) => (
    <Container>
        <TextContainer>
            <BodyText copyColor={colors.primary.snow} size="md">
                {hoverText}
            </BodyText>
        </TextContainer>
    </Container>
);

HoverTextOverlay.propTypes = {
    hoverText: PropTypes.string.isRequired
};

export default HoverTextOverlay;
